import { useEffect, useMemo, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import Loader from "components/Common/loader";
import {
  createEmployeeTarget,
  updateEmployeeTarget,
} from "services/employeeTarget";
import { useSelector } from "react-redux";

const AddEmployeeTarget = ({ onClose, rowData }) => {
  const { reset } = useForm({
    defaultValues: useMemo(() => rowData, [rowData]),
  });

  const auth = useSelector((state) => state.jwtAuthreducer);

  const { showAlert } = useAlert();

  const onSuccess = () => {
    const refetch = true;
    const message = rowData
      ? "Employee target updated successfully!"
      : "Employee target created successfully!";
    showAlert(message, "success");
    onClose(refetch);
  };

  const onError = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;
    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: createTarget, isLoading: isCreating } = useMutation({
    mutationFn: createEmployeeTarget,
    onSuccess,
    onError,
  });

  const { mutate: updateTarget, isLoading: isUpdating } = useMutation({
    mutationFn: updateEmployeeTarget,
    onSuccess,
    onError,
  });

  const isSubmitting = isCreating || isUpdating;

  const handleSubmit = (values, e) => {
    e.preventDefault();

    const payload = {
      employee_code_id: values.employee_id,
      target: Number(values.target),
      target_type: values.target_type,
      financial_year: values.financial_year,
      is_active: true,
      created_by:
        auth?.user?.employee_code_id ||
        localStorage.getItem("employee_code_id"),
    };

    if (rowData) {
      updateTarget({
        id: rowData?.id,
        ...payload,
      });
    } else {
      createTarget(payload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading />
        </div>
      )}

      <CustomForm
        config={FORM_CONFIG(rowData)}
        onSubmit={handleSubmit}
        columnCount={2}
        rowData={rowData}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddEmployeeTarget;
